mod.modules.define("ScreenerPage", "BaseScreenerPage", function(fn) {

	// --------------------------------------------------------------------------
	// Init
	// --------------------------------------------------------------------------

    fn.prototype.init = function (params) {

		this.base("init", params);

		var self = this;

		this.$screenerContainer = $('#screener-page');
		this.$screenerContent = this.$screenerContainer.find('div.screener-content');
		this.$screenerNav = this.$screenerContainer.find('div.criteriaBuckets');
		this.$screenerFilterArea = this.$screenerContainer.find('div.activeCriteria ul#sortable');
		this.$showAvailableStocksOnly = this.$screenerContainer.find('div.showAvailableStocksOnly');
		this.$screenerCreateScreenBtn = this.$screenerContainer.find("button[data-action=create-screen]");
		this.$screenerUpdateScreenBtn = this.$screenerContainer.find("button[data-action=update-screen]");
		this.$criteriaTab = $("#tab-criteria");
		this.$customTab = $("#tab-custom");
		this.hasRunScreenerBefore = false;
		this.showAvailableFilterIsOn = false;

		this.initScreener();

		// Look for a saved screen to load
		if (params.savedScreenId || params.predefinedScreenId) {
			setTimeout(function() {
				self.savedScreenId = params.savedScreenId || params.predefinedScreenId;
				self.savedScreenName = params.savedScreenName || params.predefinedScreenName;
				self.loadSavedScreen(self.savedScreenId);
			}, 0);
		}

		this.initFilterDraggable();

		if (params.numFiltersAllowed) {
			this.numFiltersAllowed = params.numFiltersAllowed;
		}
		
		this.initTooltips();
	};

	fn.prototype.initScreener = function() {
		this.base("initScreener");
	};

	fn.prototype.initFilterDraggable = function() {
		var self = this;

		// Activate drag and drop
		var sortObj = this.$screenerContainer.find('#sortable').sortable({
			axis: 'y',
			handle: '.screener-filter-name',
			containment: "parent",
			stop: function() {
				mod.observer.trigger("screener - screen");
			}
		});
	};

	// --------------------------------------------------------------------------
	// Screens
	// --------------------------------------------------------------------------

	fn.prototype.runScreen = function(resultFields, resetPaging) {
		if (!this.disableScreening) {
			if (resetPaging) {
				this.resetPaging();
			}

			// Get all the inputs for the screen
			this.buildScreenInputs(resultFields);

			this.ScreenerUtilityInstance.DoPreScreen(true);
			this.ScreenerUtilityInstance.DoScreen(true);

			// Handle the first load
			this.handleNoFilters();
		}
	};

	fn.prototype.runPreScreen = function() {
		if (!this.disableScreening) {
			// Get all the inputs for the screen
			this.buildScreenInputs();

			this.ScreenerUtilityInstance.DoPreScreen(true);

			// Handle the first load
			this.handleNoFilters();
		}
	};

	fn.prototype.buildScreenInputs = function(resultFields) {
		this.base("buildScreenInputs", resultFields);

		var $filters = this.$screenerFilterArea.find("li.screener-filter");
		var safeNames = [];

		// Add each user filter
		for (var i = 0; i < $filters.length; i++) {
			var $filter = $filters.eq(i);
			var filterController = $filter.data("controller");
			var argument = filterController.getArgument();
			this.ScreenerInputs.AddArgument(argument);

			var safeName = argument.GetSafeName();
			safeNames.push(safeName);
		}

		// Add the "Available Stocks" Filter (has to be done manually since it's not a part of the "normal" area
		//Bit of a hack here to manually check deep on it.
		var $subFilter = $("div.screener-component-showavailabletoggle", this.$showAvailableStocksOnly);
		for (var i = 0; i < $subFilter.length; i++) {
			var $filter = $subFilter.eq(i);
			var filterController = $filter.data("controller");
			if (filterController !== null && filterController !== undefined && filterController.getArgument !== undefined) {
				var argument = filterController.getArgument();
				
				//Only include if on
				if (argument && argument._Data && argument._Data.Clauses.length > 0) {
					if (argument._Data.Clauses[0] && argument._Data.Clauses[0]._Data && argument._Data.Clauses[0]._Data.Values.length > 0) {
						if (argument._Data.Clauses[0]._Data.Values[0] == "1") {
							this.ScreenerInputs.AddArgument(argument);

							var safeName = argument.GetSafeName();
							safeNames.push(safeName);
						}
					}
				}
			}
		}

		// Update the criteria tab with the arguments fields
		if (!resultFields && this.$criteriaTab.parent().hasClass("active")) {
			resultFields = this.defaultColumns.concat(safeNames);
			this.$criteriaTab.attr("data-fields", JSON.stringify(resultFields));

			this.ScreenerInputs.SetResultFields(resultFields);
		}

		this.addExcludedIssueIdArgs(this.excludedIssueIds);
	};

	fn.prototype.screenRequestCallback = function(response) {
		this.base("screenRequestCallback", response);

		if (!this.hasRunScreenerBefore) {
			var screenerUtil = this.ScreenerUtilNamespace.ScreenerUtility;
			// Manually instantiate our special filter.
			var $subFilter = $("div.screener-component-showavailabletoggle", this.$showAvailableStocksOnly);
			var initFn = $subFilter.data("initfn");
			var filterController = mod.filters.create(initFn, $subFilter, {
				screenerNamespace: screenerUtil,
				argument: this.showAvailableFilterIsOn
			});

			// Save the controller to the dom node
			$subFilter.data("controller", filterController);

			this.hasRunScreenerBefore = true;
		}

	};

	fn.prototype.preScreenRequestCallback = function(response) {
		this.base("preScreenRequestCallback", response);

		var self = this;

		if (response && response.status == 1) {
			// Update each filter
			if (response.filterTotals) {
				var totalCompanies = response.totalCompanies || 0;

				// Update each filter's count
				this.$screenerFilterArea.children().each(function(i, filter) {
					var $filter = $(filter);
					var matches = response.filterTotals[i];
					var formattedMatches = self.formatAddCommas(matches);

					// Update the match count
					$filter.find("div.matches").text(formattedMatches);

					// Update the match bar
					var percentOfTotal = Math.round(matches / totalCompanies * 100);
					$filter.find("span.matchBarInner").width(percentOfTotal + "%");
				});
			}

			// Update the total result number
			var formattedTotal = this.formatAddCommas(response.matches);
			$('.stockScreenResultCount .result').text(formattedTotal);

			// Update our hidden count - this will need to be sent from the server!
			var hiddenTotal = this.formatAddCommas(response.hiddenCount);
			$('.stockScreenResultCount .showAvailableStocksOnly .infoArea .resHidden').text(hiddenTotal);

		}
	};

	// --------------------------------------------------------------------------
	// Saved Screens
	// --------------------------------------------------------------------------
	fn.prototype.saveScreen = function(name, isNew) {
		var filterTypes = [];
		var filterCategories = [];

		this.$screenerFilterArea.find("li.screener-filter").each(function(i, filter) {
			filterTypes.push(filter.getAttribute('data-type'));
			filterCategories.push(filter.getAttribute('data-category'));
		});

		// Add the "Available Stocks" Filter (has to be done manually since it's not a part of the "normal" area
		//Bit of a hack here to manually check deep on it.
		$("div.screener-component-showavailabletoggle", this.$showAvailableStocksOnly).each(function (i, filter) {
			filterTypes.push(filter.getAttribute('data-type'));
			filterCategories.push(filter.getAttribute('data-category'));
		});
		
		// Get all the arguments
		this.buildScreenInputs();
		// Grab the official inputs from the utility
		var screenInputs = this.ScreenerUtilityInstance.GetInputs(true);
		
		var id = (isNew) ? '' : this.savedScreenId;

		$.ajax({
			url: "SaveScreen",
			type: "post",
			dataType: "json",
			data: {
				id: id,
				name: name,
				filterTypes: JSON.stringify(filterTypes),
				filterCategories: JSON.stringify(filterCategories),
				screenInputs: JSON.stringify(screenInputs)
			},
			context: this,
			success: function(screenId) {
				if (screenId) {
					this.redirectToScreen(screenId);
				}
			},
			error: function error() {
				alert("There was an error when trying to save your screen.");
			}
		});
	};

	fn.prototype.deleteSavedScreen = function(screenId) {
		if (screenId) {
			$.ajax({
				url: "DeleteScreen",
				type: "post",
				dataType: "json",
				data: {
					screenId: screenId
				},
				context: this,
				success: function(screenId) {
					// Redirect to main screener page
					// Make a random number to break cache on the landing page
					window.location = location.pathname + "?c=" + Math.round(Math.random() * 10000);
				},
				error: function error() {
					alert("No delete!");
				}
			});
		}
	};

	fn.prototype.loadSavedScreen = function(screenId) {
		var self = this;

		if (screenId) {
			// Disable screening
			this.disableScreening = true;

			$.ajax({
				url: "GetScreen",
				dataType: "json",
				data: {
					screenId: screenId
				},
				cache: false,
				context: this,
				beforeSend: function() {
					this.showLoading();
				},
				success: function (response) {
					// Add the filters
					for (var i = 0; i < response.Filters.length; i++) {
						var html = response.Filters[i];
						var arg = response.Screen.Arguments[i];
						var category = arg.CategoryType;
						var type = arg.FilterType;
						this.addFilterModule(html, type, category, arg);
					}

					if (response.Screen && response.Screen.SortArgument) {
						var newSortSafeName = response.Screen.SortArgument.Field || this.defaultSortSafeName;
						var newSortDir = response.Screen.SortArgument.Direction || 'Ascending';
						
						// Remove the previous args
						this.ScreenerInputs.RemoveSortArguments();

						this.ScreenerInputs.AddSortArgument(
							new this.ScreenerUtilNamespace.ScreenerUtility.ScreenInputs.SortArgument(
								newSortSafeName,
								ScreenerUtility.SORT_DIRECTION[newSortDir]
							)
						);
					}

					this.showAvailableFilterIsOn = response.ShowAvailableFilter;

					// Enable screening after everything else finishes
					// The loading indicator will stop when the screen finishes
					setTimeout(function () {
						self.disableScreening = false;
						self.updateFilterCounts();
						self.runScreen();
					}, 50);
					
				},
				error: function error() {
					alert("The saved screen failed to load.");
					this.hideLoading();
				}
			});
		}
		else {
			console.warn("Tried to load screen, but there was no 'screenId'");
		}
	};

	fn.prototype.handleSaveScreen = function($modalBody, isNew) {
		var $errorMsg = $modalBody.find("p.error-msg");
		var $input = $modalBody.find("input[type=text]");
		var name = $input.val();

		if (name) {
			this.saveScreen(name, isNew);
			$modalBody.modal("hide");
			$errorMsg.hide();
			$input.val("");
		}
		else {
			$errorMsg.text("Please enter a name for your saved screen.");
			$errorMsg.show();
		}
	};

	// --------------------------------------------------------------------------
	// Filters
	// --------------------------------------------------------------------------

	fn.prototype.getFilterModule = function(filterType, categoryType) {
		mod.observer.trigger("screener - add filter", filterType);

		$.ajax({
			url: "GetFilter",
			dataType: "json",
			data: {
				filterType: filterType
			},
			cache: false,
			context: this,
			success: function(response) {
				if (response && response.status) {
					// Add the filter
					this.addFilterModule(response.filterHtml, filterType, categoryType);

					// Run the screen to update results
					this.runScreen();

					// Update the count
					this.updateFilterCounts();
				}
			},
			error: function error() {
				this.logError("Could not load filter: '" + filterType + "'");
				this.hideLoading();
			},
			beforeSend: function() {
				this.showLoading();
			},
			complete: function() { }
		});
	};

	fn.prototype.addFilterModule = function(html, filterType, filterCategory, argument) {
		if (html) {
			var $filter = $(html);

			// Add the html to the DOM
			this.$screenerFilterArea.append($filter);

			// Force the collapsed filters open or else they won't work
			// This is because they rely on ":visible"
			this.toggleFilterCollapse(true);

			// Instantiate the filter controller class
			var filterController = mod.filters.create(filterCategory, $filter, {
				screenerNamespace: this.ScreenerUtilNamespace.ScreenerUtility,
				argument: argument
			});

			// Save the controller to the dom node
			$filter.data("controller", filterController);

			// Make sure the filter shows as selected on the nav
			this.$screenerNav.find("a[data-filtertype=" + filterType + "]").addClass("active");

			// Setup the help tooltip if there is one
			$filter.find("a.infoIcon").tooltip({
				maxWidth: 215,
				html: true
			});
		}
	};

	fn.prototype.removeFilterModule = function($filters, skipScreen) {
		$filters = $($filters);

		var sortArgs = this.ScreenerInputs.GetSortArguments();

		for (var i = 0; i < $filters.length; i++) {
			var $filter = $filters.eq(i);
			var safeName = $filter.attr('data-safename') || '';;

			// Check to see if this filter was the one we're sorting on
			if (sortArgs.length && sortArgs[0]._Data.Field.toLowerCase() === safeName.toLowerCase()) {
				this.resetSorting();
			}

			// Remove the filter from DOM
			$filter.remove();

			// Deactivate the filter from the nav
			var filterType = $filter.attr("data-type");
			this.$screenerContainer.find("ul.criteria a[data-filtertype='" + filterType + "']").removeClass("active");
		}

		// Update the count
		this.updateFilterCounts();

		if (!skipScreen) {
			// Re-run the screen
			this.runScreen();
		}
	};

	fn.prototype.updateFilterCounts = function() {
		var $filterGroups = this.$screenerNav.find("ul").children();

		for (var i = 0; i < $filterGroups.length; i++) {
			var $group = $filterGroups.eq(i);
			var $activeFilters = $group.find("li a.active");
			var $bucketNum = $group.find("a.criteriaBucket span.filterCount");
			var text = ($activeFilters.length) ? "(" + $activeFilters.length + ")" : "";
			$bucketNum.text(text);
		}
	};

	fn.prototype.handleNoFilters = function() {
		var hasCriteria = this.$screenerFilterArea.children().length > 0;

		if (hasCriteria) {
			this.$screenerContainer.removeClass("noFilters");

			// Enable the "Create Screen" buttons
			this.$screenerCreateScreenBtn.attr("disabled", false);
			this.$screenerUpdateScreenBtn.attr("disabled", false);
		}
		else {
			this.$screenerContainer.addClass("noFilters");

			// Disable the "Create Screen" buttons
			this.$screenerCreateScreenBtn.attr("disabled", "disabled");
			this.$screenerUpdateScreenBtn.attr("disabled", "disabled");
		}
	};

	// --------------------------------------------------------------------------
	// Utils
	// --------------------------------------------------------------------------

	fn.prototype.toggleFilterCollapse = function(forceOpen) {
		var self = this;
		var hasCriteria = this.$screenerFilterArea.find('li').length;
		var speed = 0;

		if (hasCriteria) {
			var isCollapsed = this.$screenerFilterArea.hasClass("collapsed");
			var $tabLink = this.$screenerContainer.find('.screenFooter .tab a');

			if (isCollapsed || forceOpen) {
				this.$screenerFilterArea.slideDown(speed, function() {
					self.$screenerFilterArea.removeClass("collapsed");
					$tabLink.text("Collapse criteria");
				});

				// Show drag and drop text
				$('div.dragDropDirection').css('visibility', 'visible');
			}
			else {
				this.$screenerFilterArea.slideUp(speed, function() {
					self.$screenerFilterArea.addClass("collapsed");
					$tabLink.text("Expand criteria");
				});

				// Hide drag and drop text
				$('div.dragDropDirection').css('visibility', 'hidden');
			}
		}
	};

	fn.prototype.formatAddCommas = function(value) {
		var output = value;

		if (value) {
			output = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		}

		return output;
	};

	fn.prototype.redirectToScreen = function(screenId) {
		window.location = location.pathname + "?savedScreenId=" + screenId;
	};

	fn.prototype.redirectToPredefinedScreen = function(screenId) {
		window.location = location.pathname + "?predefinedScreenId=" + screenId;
	};

	fn.prototype.logError = function(msg) {
		// $.ajax({
		// 	url: "~/logs/LogMessage",
		// 	data: {
		// 		isException: true,
		// 		title: "Screener",
		// 		msg: msg
		// 	}
		// });
	};

	fn.prototype.launchExpandedWindow = function() {
		// Get the current set of inputs
		var currentInputs = this.ScreenerUtilityInstance.GetInputs(true);

		// Get the filter arguments and replace the result fields
		var fieldsJson = this.$criteriaTab.attr("data-fields");
		var filterFields = JSON.parse(fieldsJson);
		currentInputs.ResultFields = filterFields;

		// Build up the url
		var url = "~/screener/expandedview".resolveUrl();// + "?inputs=" + JSON.stringify(currentInputs);

		var windowOptions = [
			"menubar=no",
			"status=no",
			"toolbar=no",
			"location=no"
		];

		window.open(url, "Expanded_Screener", windowOptions.join(","), true);
	};


	fn.prototype.initTooltips = function () {

		this.el.find("a.tooltip-trigger").tooltip({ html: true, maxWidth: 340 });

	};

	fn.prototype.events = {
		// --------------------
		// Saved Screens
		// --------------------
		"button[data-action=create-screen]:not([disabled])": {
			"click": function(e, $el) {
				$("#screener_create_screen").modal();
			}
		},
		"button[data-action=update-screen]:not([disabled])": {
			"click": function(e, $el) {
				$("#screener_update_screen").modal();
			}
		},
		"#screener_create_screen [data-action=save]": {
			"click": function(e, $el) {
				var $parent = $el.closest("div.modal");
				this.handleSaveScreen($parent, true);
			}
		},
		"#screener_update_screen [data-action=save]": {
			"click": function(e, $el) {
				var $parent = $el.closest("div.modal");
				this.handleSaveScreen($parent);
			}
		},
		"div.modal [data-action=cancel]": {
			"click": function(e, $el) {
				$el.closest("div.modal").modal("hide");
			}
		},
		"button[data-action=delete-screen]": {
			"click": function(e, $el) {
				this.deleteSavedScreen(this.savedScreenId);
			}
		},
		"button[data-action=delete-screen-prompt]": {
			"click": function(e, $el) {
				$("#screener_delete_screen").modal();
			}
		},
		"[data-screenid]": {
			"click": function(e, $el) {
				var screenId = $el.attr("data-screenid");
				this.redirectToScreen(screenId);
			}
		},
		"[data-predefinedscreenid]": {
			"click": function(e, $el) {
				var screenId = $el.attr("data-predefinedscreenid");
				this.redirectToPredefinedScreen(screenId);
			}
		},
		// --------------------
		// Filters
		// --------------------
		"div.screener-content [data-filtertype]": {
			"click": function(e, $el) {
				var filterType = $el.attr("data-filtertype");
				var categoryType = $el.attr("data-categorytype");

				if ($el.hasClass("active")) {
					var $filter = this.$screenerFilterArea.find("li.screener-filter[data-type=" + filterType + "]");

					mod.observer.trigger("screener - remove filter", $filter);
				}
				else {
					var numCurrentFilters = this.$screenerFilterArea.find("li.screener-filter").length;

					if (numCurrentFilters < this.numFiltersAllowed) {
						// Grab the new filter
						this.getFilterModule(filterType, categoryType);
					}
					else {
						alert("You cannot add more than " + this.numFiltersAllowed + " filters");
					}
				}
			}
		},
		'[data-action=resetfilters]': {
			'click': function(e, $el) {
				var $allFilters = this.$screenerFilterArea.find('.screener-filter');
				this.removeFilterModule($allFilters);
			}
		},
		
		// --------------------
		// Tabs
		// --------------------
		".icon-screenerexpand": {
			"click": function(e, $el) {
				this.launchExpandedWindow();

				mod.observer.trigger("screener - launch expanded window");
			}
		},
		// --------------------
		// Misc
		// --------------------
		".screenFooter .tab a": {
			"click": function(e, $el) {
				this.toggleFilterCollapse();
			}
		},
		"a.criteriaBucket": {
			"click": function(e, $el) {
				$el.closest('li').toggleClass("open").toggleClass("closed");
			}
		}
	};

	fn.prototype.observables = {
		"screener - screen": function(options) {
			options = options || {};
			this.runScreen(null, options.resetPaging);
		},
		"screener - showAvailableFilter": function (options) {
			options = options || {};
			this.runScreen(null, options.resetPaging);
		},
		"screener - remove filter": function ($filter) {
			this.removeFilterModule($filter);
		},
		"custom columns saved": function(newFields) {
			var customFields = this.defaultColumns.concat(newFields);
			this.$customTab.attr("data-fields", JSON.stringify(customFields));

			// Select the "Custom" tab, which will rerun the screen
			this.$customTab.tab("show");

			this.runScreen(customFields);
		}
	};

});